import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    serviceId: PropTypes.number.isRequired,
    serviceGenres: PropTypes.array.isRequired,
  },
  scrollCurrentServiceTab() {
    // id="current-service"が付いているタブまでスクロール
    var currentService = document.getElementById("current-service");
    var contentWidth = currentService.clientWidth;
    var tabXPos = currentService.getBoundingClientRect();
    var serviceGenreTab = document.getElementById("service-genre-tab");
    var displayWidth = window.parent.screen.width;
    serviceGenreTab.scrollLeft =
      tabXPos.left - (displayWidth - contentWidth) / 2;

    // 下線バーの色を変更
    serviceGenreTab.classList.add(
      currentService.dataset.service + "-borderbottom-color"
    );
  },
  componentDidMount() {
    this.scrollCurrentServiceTab();
  },
  render() {
    const serviceGenres = this.props.serviceGenres.map(function(serviceGenre) {
      if (this.props.serviceId === serviceGenre.id) {
        return (
          <div
            className={`genre-box current-service ${serviceGenre.subdomain +
              "-background-color"}`}
            id="current-service"
            data-service={serviceGenre.subdomain}
            key={serviceGenre.id}
          >
            <a href={`/${serviceGenre.subdomain}`}>
              <p className="mb0">{serviceGenre.name}</p>
            </a>
          </div>
        );
      } else {
        return (
          <div className={`genre-box`} key={serviceGenre.id}>
            <a
              className={serviceGenre.subdomain + "-color"}
              href={`/${serviceGenre.subdomain}`}
            >
              <p className="mb0">{serviceGenre.name}</p>
            </a>
          </div>
        );
      }
    }, this);

    var top = "";
    if (this.props.serviceId === 1) {
      top = (
        <div className="genre-box current-service" id="current-service">
          <a href="/">
            <p className="mb0">トップ</p>
          </a>
        </div>
      );
    } else {
      top = (
        <div className="genre-box">
          <a className="top-color" href="/">
            <p className="mb0">トップ</p>
          </a>
        </div>
      );
    }

    return (
      <div className={`service-genre-tab`} id="service-genre-tab">
        {top}
        {serviceGenres}
      </div>
    );
  },
});
